import { render, staticRenderFns } from "./FlujosAprobacion.vue?vue&type=template&id=da1cde3c&"
import script from "./FlujosAprobacion.vue?vue&type=script&lang=js&"
export * from "./FlujosAprobacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FlujosAprobacion.vue"
export default component.exports